// extracted by mini-css-extract-plugin
module.exports = {"input":"Input_input__3PNbO","dark":"Input_dark__2KqW0","mini":"Input_mini__30EC6","normal":"Input_normal__1Bb05","big":"Input_big__24l30","textarea":"Input_textarea__h_Kof"};